import React from 'react';

import type { LessonNotificationContextType } from './lesson-notification-context';
import { LessonNotificationContext } from './lesson-notification-context';

export const useLessonNotificationContext = () =>
  React.useContext<LessonNotificationContextType>(LessonNotificationContext);
